import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const moreResultsHint = style([
  typography.bodySm,
  {
    padding: space.s8,
    color: themeVars.container.foreground.tertiary,
  },
]);
